import React from 'react';

const CommentIcon = () => {
    return (
        <svg
            width='33'
            height='32'
            viewBox='0 0 33 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            {/* <circle cx="16.5" cy="16" r="16" fill="#696969" fillOpacity="0.6" /> */}
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M10.6572 24.0095L7.91667 26.75V21.727C6.40625 19.9628 5.5 17.7165 5.5 15.2708C5.5 9.59892 10.3696 5 16.375 5C22.3804 5 27.25 9.59892 27.25 15.2708C27.25 20.9428 22.3804 25.5417 16.375 25.5417C14.3668 25.5481 12.3931 25.0192 10.6572 24.0095Z'
                fill='#696969'
            />
        </svg>
    );
};

export default CommentIcon;
